// extracted by mini-css-extract-plugin
export default {"capa":"Index_capa__+synl","adai":"Index_adai__YAdjA","menu_responsivo":"Index_menu_responsivo__dygKO"};